export default "__VITE_ASSET__D8KkAt3L__"